(() => {
  /**
   * ============================================================
   * Free Pouch Pod Campaign
   * ============================================================
   */

  const CONFIG = {
    campaignParam: "campaign",
    campaignValue: "freepod25",

    // Free Pouch Pod Variant
    giftVariantId: 43106288992330,

    // Spider + Moth (add Rodent & Ant later)
    qualifyingVariants: [
      // Spider
      43183086043210,
      43183086075978,
      43432875262026,

      // Moth
      43183111798858,
      43183111831626,
      43432876146762,
      // rodent
      43183030665290,
      43183030632522,
      43200636059722,
      43200636092490,
      //antro
      43183019917386,
      43183019950154,
      43432851210314,
    ],

    storageKey: "freepod25-campaign",

    debug: true
  };

 let syncing = false;

  function log(...args) {
    if (CONFIG.debug) {
      console.log("[FREEPOD]", ...args);
    }
  }

  /**
   * --------------------------------------------------
   * Detect Campaign
   * --------------------------------------------------
   */
async function detectCampaign() {

    const params = new URLSearchParams(window.location.search);

    if (params.get(CONFIG.campaignParam) !== CONFIG.campaignValue) {
        return;
    }

    log("Campaign detected");

    const cart = await getCart();

    if (
        cart.attributes &&
        cart.attributes.freepod_campaign === "true"
    ) {
        log("Campaign already stored");
        return;
    }

    await fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            attributes: {
                freepod_campaign: "true"
            }
        })
    });

    log("Campaign attribute saved");

    params.delete(CONFIG.campaignParam);

    window.history.replaceState(
        {},
        "",
        window.location.pathname +
        (params.toString() ? "?" + params.toString() : "") +
        window.location.hash
    );

}

async function isCampaignCustomer() {

    const cart = await getCart();

    const hasDiscount =
        cart.discount_codes &&
        cart.discount_codes.some(discount =>
            discount.code.toUpperCase() === "FREEPOD25"
        );

    log("Campaign Customer:", hasDiscount);

    return hasDiscount;
}

  /**
   * --------------------------------------------------
   * Cart Helpers
   * --------------------------------------------------
   */

  async function getCart() {
    const response = await fetch("/cart.js");

    return await response.json();
  }

  function hasQualifyingProduct(cart) {
    return cart.items.some(item =>
      CONFIG.qualifyingVariants.includes(item.variant_id)
    );
  }

function getCampaignGift(cart) {
  return cart.items.find(item =>
    item.variant_id === CONFIG.giftVariantId &&
    item.properties &&
    item.properties._campaign_gift === "true"
  );
}

function hasManualGift(cart) {
  return cart.items.some(item =>
    item.variant_id === CONFIG.giftVariantId &&
    (
      !item.properties ||
      item.properties._campaign_gift !== "true"
    )
  );
}

  /**
   * --------------------------------------------------
   * Add Gift
   * --------------------------------------------------
   */

async function addGift() {

  log("Adding Campaign Pouch Pod");

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: [
        {
          id: CONFIG.giftVariantId,
          quantity: 1,
          properties: {
            "_campaign_gift": "true"
          }
        }
      ]
    })
  });

  window.dispatchEvent(new CustomEvent("freepod:refresh"));
}

  /**
   * --------------------------------------------------
   * Remove Gift
   * --------------------------------------------------
   */

  async function removeGift(key) {

    log("Removing pouch pod");

    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });

    window.dispatchEvent(new CustomEvent("freepod:refresh"));
  }

  /**
   * --------------------------------------------------
   * Sync Cart
   * --------------------------------------------------
   */

  async function sync() {

    if (syncing) return;

    syncing = true;

    try {

  const campaignCustomer = await isCampaignCustomer();

if (!campaignCustomer) {

    log("Not campaign customer");

    return;
}

      const cart = await getCart();

const qualified = hasQualifyingProduct(cart);

const campaignGift = getCampaignGift(cart);

const manualGift = hasManualGift(cart);

log({
    qualified,
    campaignGift,
    manualGift
});

// Only add gift if:
// 1. Customer qualifies
// 2. No campaign gift already exists
// 3. Customer hasn't manually added one

if (
    qualified &&
    !campaignGift &&
    !manualGift
) {
    await addGift();
}

// Remove ONLY campaign gift

if (
    !qualified &&
    campaignGift
) {
    await removeGift(campaignGift.key);
}

    } catch (e) {

      console.error(e);

    } finally {

      syncing = false;

    }

  }

  /**
   * --------------------------------------------------
   * Refresh Drawer
   * --------------------------------------------------
   */

  window.addEventListener("freepod:refresh", () => {

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {

        if (
          typeof publish !== "undefined" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "freepod",
            cartData: cart
          });

        }

      });

  });

  /**
   * --------------------------------------------------
   * Init
   * --------------------------------------------------
   */

document.addEventListener("DOMContentLoaded", () => {

    sync();

    if (
        typeof subscribe !== "undefined" &&
        typeof PUB_SUB_EVENTS !== "undefined"
    ) {

        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {

            sync();

        });

    }

});

})();